import React from "react";

import { useTranslation } from "utils";

import { COVER_CROP_FIT_REASON, COVER_CROP_FIT_STATUS } from "consts";

import { AlertBanner } from "components";

import { CoverCropFit } from "pages/app/scenario-analysis/utils/coverCropFit";

type CoverCropFitWarningProps = {
  fit: Extract<CoverCropFit, { status: typeof COVER_CROP_FIT_STATUS.WONT_FIT }>;
  previousCropLabel: string;
  dataTestId?: string;
};

export const CoverCropFitWarning = ({ fit, previousCropLabel, dataTestId }: CoverCropFitWarningProps) => {
  const { t } = useTranslation("scenarioAnalysis");

  const getReasonText = () => {
    if (fit.reason === COVER_CROP_FIT_REASON.SOWING_WINDOW_CLOSED) {
      return fit.isPreviousCropLastYear
        ? t("scenarioBuilder.coverCropFitWarning.sowingWindowClosedLastYear", { previousCrop: previousCropLabel, year: fit.previousCropYearNumber })
        : t("scenarioBuilder.coverCropFitWarning.sowingWindowClosed", { previousCrop: previousCropLabel });
    }
    return fit.isPreviousCropLastYear
      ? t("scenarioBuilder.coverCropFitWarning.shortWindowLastYear", {
          previousCrop: previousCropLabel,
          year: fit.previousCropYearNumber,
          count: fit.minimumDurationMonths,
        })
      : t("scenarioBuilder.coverCropFitWarning.shortWindow", { previousCrop: previousCropLabel, count: fit.minimumDurationMonths });
  };

  return (
    <AlertBanner
      type="warning"
      iconName="tabler/alert-triangle"
      iconSize={16}
      iconAlign="start"
      className="year-row-cover-crop-fit-warning"
      dataTestId={dataTestId}
      description={
        <span className="year-row-cover-crop-fit-warning-text">
          <span className="year-row-cover-crop-fit-warning-title">{t("scenarioBuilder.coverCropFitWarning.mightNotBeSown")}</span> {getReasonText()}
          {fit.wouldFitBeforeSpringCrop && <> {t("scenarioBuilder.coverCropFitWarning.springCropHint")}</>}
        </span>
      }
    />
  );
};

export default CoverCropFitWarning;
